<wiz-vgroup #actionContainer height="100%" width="100%"
  style="border-style: outset; border-width: thin; padding: 2px;">
  
  <wiz-hgroup width="100%" verticalAlign="center">
    <i *ngIf="state" class="material-icons" style="padding-right:5px;">{{icon}}</i>
    <!-- {{idx}} -->
    <wiz-label *ngIf="state" [wizLabel]="state" class="smallFont"></wiz-label>
    <wiz-label *ngIf="startDate" [wizLabel]="startDate" class="smallFont"></wiz-label>
    <wiz-label *ngIf="endDate" [wizLabel]="endDate" class="smallFont"></wiz-label>  
  </wiz-hgroup>

  
  <wiz-hgroup width="100%" height="100%" verticalAlign="center" style="overflow-y: auto;">
      <span class="wiz-cell-text" >{{content}}</span>
  </wiz-hgroup>
  

  <wiz-hgroup width="100%" verticalAlign="center">
    <wiz-icon [wizTooltip]="'$.common.edit.$'" [visible]="isMine()"
        class="basicIcon black hoversave" (click)="doEditReply()">edit</wiz-icon>
    <wiz-spacer width="100%"></wiz-spacer>
    <wiz-label [wizLabel]="createTime" class="smallFont"></wiz-label>
    <wiz-label [wizLabel]="createBy" class="smallFont"></wiz-label>
    <wiz-icon [visible]="notFirst()" [wizTooltip]="'$.wf.deletereply.$'" 
        class="basicIcon black hoversave" (click)="doDeleteReply()">delete</wiz-icon>
  </wiz-hgroup> 
  


</wiz-vgroup>
